import React, { useState, useEffect } from 'react'
import { BackArrowFeed, InfoIconBranding, CalendarChallengeIcon, LocationChallengeIcon, PeopleChallengeIcon, RewardsChallengeIcon, WellnessGalIcon, WatchIcon, CompleteTaskIcon, AudioIcon, AddIconBranding, ProgressTickIcon } from '../../../utils/icons'
import PropTypes from 'prop-types';
import { BadgeEarned, BottomContainer, ChallengeDetailsConatainer, ChallengeHeading, ChallengesContainer, ColorBox, DateLocationContainer, ImageLayout, LevelConatiner, PointsContainer, RightContainer } from '../../UserDashboard/styles';
import Calendar from 'react-calendar';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { commaSeperator, convertDateInTimezone,convertMonthFromDate,/* convertMonthFromDate, */fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { GetWellnessChallengeDetails } from '../../../redux/constants/apiConstants';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useLocation } from "react-router-dom";
import SkeletonLoder from '../../common/skeletonLoder';
import { CalendarPicker, CalendarWrapper } from '../../LogWorkoutCategoryV3/styles';
import { Border } from '../../RecogntionAdmin/styles';
import { ImageUrl } from '../../../utils/constants';
import { TabViewNew } from '../styles';
import { CheckBoxContainer, GoalCardContainer, TaskCalendar, TaskContainer, TextContainer } from './styles';
import JournalDetailsPage from './JournalDetailsPage';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { CommonButtonBorder } from '../../common/commonStyles';
import { Task } from '../../InputGoalsV2/styles';
import FeelingModal from './FeelingModal';
import ChallengeBadgePopup from './ChallengeBadgePopup';
import PreQuizModal from '../../UserDashboard/PreQuizModal';


function UserWellnessChallenge({ history }) {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Challenge");
  const [selectedDate, setSelectedDate] = useState(null);
  const [wellnessChallengeDetails, setWellnessChallengeDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openFeelingModal, setOpenFeelingModal] = useState(false);
  const location = useLocation();
  const isCompletedTab = location?.state?.completedTab;
  // const [isCompletedChallenge, setIsCompletedChallenge] = useState(isCompletedTab || false);
  const [isCompletedChallenge, setIsCompletedChallenge] = useState(false);
  const [showPostQuiz, setShowPostQuiz] = useState(false);
  const [showBadgePopup, setShowBadgePopup] = useState(false);

  window.console.log("id",id)



  window.console.log("isCompletedChallenge",isCompletedChallenge)
  useEffect(() => {
    window.console.log("wellnessChallengeDetails", wellnessChallengeDetails)

    if (id) {
      FetchWellnessChallenegesData(id);
    }
  }, [id])



  const FetchWellnessChallenegesData = async (challengeId) => {
    setIsLoading(true);
    try {
      const res = await fetchApi(GetWellnessChallengeDetails + "/" + challengeId, "GET");
      window.console.log("wellness challenge details", res)
      if (res.status === 'success') {
        setWellnessChallengeDetails(res.data);

        const challengeStatus = res?.data?.challenge_info?.challenge_status;
        const hasSubmittedPostQuiz = res?.data?.user_progress?.has_submitted_post_quiz;
      
        const isCompleted = challengeStatus === "completed";
        setIsCompletedChallenge(isCompleted);
      
        // ✅ YOUR MAIN LOGIC
        if (isCompleted) {
          if (hasSubmittedPostQuiz === 0 || hasSubmittedPostQuiz === null  ) {
            setShowPostQuiz(true);   // 👉 show post quiz
          } else if (hasSubmittedPostQuiz === 1) {
            setShowBadgePopup(false); // 👉 show badge
          }
        }

        const start = moment(res.data.challenge_info.challenge_started_at);
        const end = moment(res.data.challenge_info.challenge_end_at);
        const today = moment();
      
        let defaultDate;
      
        if (today.isBetween(start, end, "day", "[]")) {
          defaultDate = today.toDate();
        } else {
          defaultDate = start.toDate();
        }
      
        setSelectedDate(defaultDate);
        // if (res.data?.start_date && isCompletedTab) {
        //   const firstDay = moment(res.data.start_date).toDate();
        //   setSelectedDate(firstDay);
        // }
        // else{
        //   const today = new Date();
        //   setSelectedDate(today);
        // }

      } else {
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setIsLoading(false);  
    }
  }

  const getSelectedTask = () => {
    if (!selectedDate || !wellnessChallengeDetails) return null;
  
    const selected = moment(selectedDate).format("YYYY-MM-DD");
  
    const dayData = wellnessChallengeDetails.daily_progress_tracking.find(
      (d) => moment(d.date).format("YYYY-MM-DD") === selected
    );
  
    if (!dayData) return null;
  
    const task = wellnessChallengeDetails.all_tasks.find(
      (t) => t.task_id === dayData.task_id
    );
  
    return { ...task, ...dayData };
  };




  const popover = () => (
    <Popover
      id="points-popover"
      className="custom-popover"
    >
      <Popover.Body>
        Thanks for joining. You’ll receive your points <br />
        at the end of the challenge.
      </Popover.Body>
    </Popover>
  );



  const Attendees = () => {
    window.console.log("")
    return (
      <div className="rewardBox">
        {PeopleChallengeIcon()}
        <div className="rewardValue">
          {commaSeperator(wellnessChallengeDetails?.total_participants_count)} Attendees
        </div>
      </div>
    )
  }

  const today = moment().startOf("day");
  const endDate = moment(
    convertDateInTimezone(
      wellnessChallengeDetails?.challenge_info?.challenge_end_at
    )
  ).startOf("day");
  
  const remainingDays = endDate.diff(today, "days");

  const renderLeftContainer = () => (

    
    <div className="leftContainer">
      <ChallengeHeading>
        {wellnessChallengeDetails?.challenge_info?.title}
      </ChallengeHeading>
      <ImageLayout>
        <img src={ImageUrl + "/" + wellnessChallengeDetails?.challenge_info?.image} alt="Challenge banner" />
      </ImageLayout>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <div className="AboutHeading">About the challenge</div>
      <div className="des" style={{ margin: "12px 0 0 0" }}>
        {wellnessChallengeDetails?.challenge_info?.description}
      </div>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <DateLocationContainer>
        <div className="insideBox">
          {CalendarChallengeIcon()}
          {isCompletedChallenge  ? <div className="text">
          Ended on  {convertMonthFromDate(
              moment(convertDateInTimezone(wellnessChallengeDetails?.challenge_info?.challenge_end_at)).format("MMMM D, YYYY")
            )}
          </div> :  <div className="text">
            {/* {convertMonthFromDate(
              moment(convertDateInTimezone(wellnessChallengeDetails?.challenge_info?.challenge_started_at)).format("MMMM D")
            )} - {convertMonthFromDate(
              moment(convertDateInTimezone(wellnessChallengeDetails?.challenge_info?.challenge_end_at)).format("MMMM D, YYYY")
            )} */}

            Ends In {remainingDays} Day{remainingDays > 1 ? "s" : ""}
          </div>}
        </div>
        <div className="insideBox">
          {LocationChallengeIcon()}
          <div className="text">{wellnessChallengeDetails?.location}</div>
        </div>
      </DateLocationContainer>


      <div style={{ display: "flex" }}>
        {/* Reward Info */}
        {isCompletedChallenge && wellnessChallengeDetails?.points_earned_so_far ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardHeading">
              You Earned +{wellnessChallengeDetails?.points_earned_so_far} XP
            </div>
          </div>
        ) : !isCompletedTab ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardValue">
              {wellnessChallengeDetails?.challenge_info?.points} XP per Day On Task Completion
            </div>
          </div>
        ) : null}

        {/* Attendees always visible */}
        {wellnessChallengeDetails?.total_participants_count ? <Attendees /> : null}
      </div>

      {isCompletedChallenge ? <BadgeEarned>
        <img className="badgeIcon" src={`${ImageUrl}/${wellnessChallengeDetails?.challenge_achievement?.challenge_badge}` } alt="" />
        {/* <div>{wellnessChallengeDetails?.challenge_achievement?.challenge_badge}</div> */}
        <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"}>Badge Earned</TextContainer>
      </BadgeEarned>:null}

    </div>
  );

  //   const selectedDayData = getSelectedDateData();
  //   const selectedDayTotal = selectedDayData?.total || 0;
  //   const formattedActivityType =
  //   ActivityType?.charAt(0).toUpperCase() + ActivityType?.slice(1);

  const selectedTask = getSelectedTask();

  window.console.log("selectedTask",selectedTask)

  const isToday = selectedDate
    ? moment(selectedDate).isSame(moment(), "day")
    : false;


  const renderRightContainer = () => (
    <div>
      <RightContainer isAlignment={"flex-start"}>
        <GoalCardContainer>
          <div className="myGoalHeading">My Goal</div>
          <div className="goalText">{wellnessChallengeDetails?.challenge_info?.goal}</div>
          <div className="goalIcon">{WellnessGalIcon()}</div>
        </GoalCardContainer>
        <TextContainer isMargin={"0 0 20px 0"}>
          {moment(selectedDate).format("MMMM DD, YYYY")}
          {isToday && " Today’s Task"}
        </TextContainer>
        <TaskContainer>
          <CheckBoxContainer /*selected={selectedWellbeingPillars.includes(pillar.id) ? true : false} */>
            <div className="selection">
              {selectedTask?.is_completed ? (
                <div style={{ display:"flex", justifyContent:"center", alignItems:"center" }}>
                  {ProgressTickIcon("#FFFFFF")}  
                </div>
              ) : (
                <div /*onClick={() => setShowReflectPopup(true)}*/>
                  {AddIconBranding()}   
                </div>
              )}
            </div>
          </CheckBoxContainer>
          <div className={Task}>
            <TextContainer isTextColor={"#FEFEFE"}>{ selectedTask?.task || ""}</TextContainer>
            <div className="completionContainer">
              {selectedTask?.media_type === "mp4" && ( 
                <>
                  <div>{WatchIcon()}</div>
                  <TextContainer isTextColor={"#FEFEFE"}>Watch Video</TextContainer>
                </>)}
              {selectedTask?.media_type === "mp3" && (
                <>
                  <div>{AudioIcon()}</div>
                  <TextContainer isTextColor={"#FEFEFE"}>Listen Audio</TextContainer>
                </>
              )}
              {selectedTask?.media_type === "yes-no" && (
                <>
                  <div>{CompleteTaskIcon()}</div>
                  <TextContainer isTextColor={"#FEFEFE"}>Complete Your Task</TextContainer>
                </>
              )}
            </div>
          </div>
        </TaskContainer>


        {selectedTask?.media_type === "mp4" && (
          <CommonButtonBorder 
            width={"420px"} 
            height={"44px"} 
            margin={"0 0 20px 0"}
            onClick={() =>
              history.push({
                pathname: "/challenges/wellness-challenge-player",
                state: {
                  media_link: selectedTask?.media_link,
                  media_type: selectedTask?.media_type,
                  media_thumbnail: selectedTask?.media_thumbnail,
                  title: selectedTask?.task,
                  taskId: selectedTask?.task_id,
                  challengeId: id,
                  isToday:isToday,
                  isCompleted: selectedTask?.is_completed
                },
              })
            }>
            Watch Video
          </CommonButtonBorder>
        )}
        
        {selectedTask?.media_type === "mp3" && (
          <CommonButtonBorder 
            width={"420px"} 
            height={"44px"} 
            margin={"0 0 20px 0"} 
            onClick={() =>
              history.push({
                pathname: "/challenges/wellness-challenge-player",
                state: {
                  media_link: selectedTask?.media_link,
                  media_type: selectedTask?.media_type,
                  media_thumbnail: selectedTask?.media_thumbnail,
                  title: selectedTask?.task,
                  taskId: selectedTask?.task_id,
                  challengeId: id,
                  isToday:isToday,
                  isCompleted: selectedTask?.is_completed
                },
              })
            }>
            Listen Audio
          </CommonButtonBorder>
        )}
        
        


        {isToday && selectedTask?.media_type === "yes-no" && selectedTask?.is_completed === 0 ? (
          <>
            <TextContainer isMargin={"0 0 12px 0"}>Did you complete today’s task?</TextContainer>
        
            <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
              <CommonButtonPopup width={"204px"} height={"40px"} onClick={() => {
                window.console.log("clicked yes");
                setOpenFeelingModal(true);
              }}>
                Yes
              </CommonButtonPopup>
        
              <CommonButtonBorder width={"204px"} height={"40px"}
                onClick={() => {
                  setOpenFeelingModal(true);
                }}>
                No
              </CommonButtonBorder>
            </div>
          </> 
        ) : null}


        {/* <LevelConatiner style={{ position: "relative" }} isPadding={"8px 16px 0px 16px"}>
          <div className="dateContainer">
            {moment(selectedDate).format("MMM DD, YYYY")}</div>
        </LevelConatiner> */}
        <LevelConatiner style={{ display: "block" }}>
          <CalendarView />
          <BottomContainer isWidthSize={"127px"}>
            <div className="secondRow seconRowMargin">
              <div className="rowContennt">
                <ColorBox />
                <div className="textBox">Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#FDD2CB" />
                <div className="textBoxForNC">Not Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#DCDCDC" />
                <div className="textBox">NA</div>
              </div>
            </div>
          </BottomContainer>

        </LevelConatiner>

        <LevelConatiner>
          <img className="levelImage" src={ImageUrl + "/" + wellnessChallengeDetails?.icon}></img>
          <div className="levelName">{wellnessChallengeDetails?.level_name} Level</div>
        </LevelConatiner>
        <PointsContainer>
          <div className="pointeSection">
            <div className="heading">{isCompletedTab ? "Total Points Earned - " : "Points earned so far - "} <span className="pointValue">{wellnessChallengeDetails?.points_earned_so_far}XP</span></div>
            {isCompletedTab ? null : <OverlayTrigger placement="bottom" overlay={popover()} containerPadding={10}
              popperConfig={{ strategy: 'fixed' }}>
              <div className="icon">{InfoIconBranding()}</div>
            </OverlayTrigger>}
          </div>
        </PointsContainer>
      </RightContainer>
    </div>

  );



  const CalendarView = () => {
    // const isFutureDate = (date) => {
    //   window.console.log("")
    //   return moment(date).isAfter(moment(), "day");
    // };

    // const isSameDay = (date1, date2) => {
    //   window.console.log("")
    //   return moment(date1).isSame(moment(date2), "day");
    // };

    // const getCalendarStatus = (date) => {
    //   window.console.log("")
    //   return wellnessChallengeDetails?.calendar?.find((item) =>
    //     moment(item.date).isSame(moment(date), "day")
    //   );
    // };

    // const startOfMonth = isCompletedTab ? moment(wellnessChallengeDetails?.challenge_started_at).toDate() : moment().startOf("month").toDate();
    // const endOfMonth = isCompletedTab ? moment(wellnessChallengeDetails?.challenge_end_at).toDate() : moment().endOf("month").toDate();

    const startDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_started_at).toDate();
    const endDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_end_at).toDate();
    
    const isOutsideRange = (date) => {
      window.console.log("")
      return (
        moment(date).isBefore(startDate, "day") ||
        moment(date).isAfter(endDate, "day")
      );
    };


    return (
      <CalendarWrapper>
        <CalendarPicker>
          <TaskCalendar>
            <Calendar
              value={selectedDate}
              onChange={setSelectedDate}
              prevLabel={null}
              minDate={startDate}
              maxDate={endDate}
              nextLabel={null}
              prev2Label={null}
              navigationLabel={null}
              next2Label={null}
              formatShortWeekday={(locale, date) =>
                date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
              }
              /* 🎨 COLORS */
              tileClassName={({ date, view }) => {
                if (view !== "month") return null;
              
                const isOutside =
                  moment(date).isBefore(startDate, "day") ||
                  moment(date).isAfter(endDate, "day");
              
                if (isOutside) return "na"; // 👈 GREY

                  
                const today = moment();
                // ⚠️ Future BUT inside challenge → light grey (#F8F8F8)
                if (moment(date).isAfter(today, "day")) {
                  return "future";
                }
                  
              
                const status = wellnessChallengeDetails?.daily_progress_tracking.find(
                  (d) => moment(d.date).isSame(date, "day")
                );
              
                let className = "";
              
                if (status) {
                  className = status.is_completed ? "completed" : "missed";
                }
              
                if (selectedDate && moment(date).isSame(selectedDate, "day")) {
                  className += " selected";
                }
              
                return className.trim();
              }}

              tileDisabled={({ date }) => {
                const today = moment();
              
                return (
                  isOutsideRange(date) ||
                  moment(date).isAfter(today, "day")   // ✅ disable future
                );
              }}
            />
          </TaskCalendar>
        </CalendarPicker>
      </CalendarWrapper>
    );
  }


  return (
    <div style={{ maxWidth: "1246px", padding: "24px 0px 40px 0px", margin: "auto", width: "100%" }}>
      {isLoading ?
        (<SkeletonLoder width={"100%"} height={"700px"} style={{ marginTop: "25px" }} />)
        :
        (<>
          <ChallengesContainer>
            <div className='right-row'>
              <div className="icon"
                onClick={() => {
                  if (isCompletedTab) {
                    history.push({
                      pathname: "/challenges/completed",
                      state: { activeSubTab: "monthly" }
                    });
                  } else {
                    history.push("/portal");
                  }
                }}>
                {BackArrowFeed("#DA6C74")}
              </div>
              <TabViewNew
                width
                padding
                margin={"0px 16px 0px 0px"}
                height="40px"
                active={activeTab == "Challenge" ? 1 : 0}
                onClick={() => setActiveTab("Challenge")}
              >
                {"Challenge"}
              </TabViewNew>
              <TabViewNew
                width
                padding
                margin={"0px 16px 0 0"}
                height="40px"
                active={activeTab == "Journal" ? 1 : 0}
                onClick={() => setActiveTab("Journal")}
              >
                {"Journal"}
              </TabViewNew>

              <TabViewNew
                width
                padding
                margin={"0px 16px 0px 0px"}
                height="40px"
                active={activeTab == "Quiz" ? 1 : 0}
                onClick={() => setActiveTab("Quiz")}
              >
                {"Quiz"}
              </TabViewNew>
            </div>

          </ChallengesContainer>

          {activeTab === "Challenge" ? <ChallengeDetailsConatainer>
            <div className="insideConatainer">
              {renderLeftContainer()}
              {renderRightContainer()}
            </div>
          </ChallengeDetailsConatainer> : null}

          {activeTab === "Journal" ? <JournalDetailsPage /> : null}
        </>
        )}




      {showPostQuiz && <PreQuizModal showModal={showPostQuiz} onHide={()=>{setShowPostQuiz(false) }} challengeId={id}  quizType={'post'}/>}
      
      
      {showBadgePopup && (
        <ChallengeBadgePopup
          showModal={showBadgePopup}
          badge={wellnessChallengeDetails?.challenge_achievement?.challenge_badge}
          points={wellnessChallengeDetails?.challenge_achievement?.challenge_points}
          onHide={() => setShowBadgePopup(false)}
        />
      )}



      {openFeelingModal && <FeelingModal  completedStatus={!selectedTask?.is_completed} taskId={selectedTask?.task_id} showModal={openFeelingModal} setActiveTab={setActiveTab}  onHide={() => setOpenFeelingModal(false)}  challengeId={id} />}
    
    </div>
  );
}

UserWellnessChallenge.propTypes = {
  history: PropTypes.object.isRequired,
};

export default UserWellnessChallenge;
